// components/job/stats/timesheet/api.js
import { getItemsFromCollection } from "directus/src/operations";

export async function fetchTimesheetApprovedHoursForMilestone({
  id,
  dateRange,
}) {
  try {
    const query = {
      fields: [
        "approved_hours",
        "consumption_factor",
        "employee.consumption_factor",
      ],
      filter: {
        milestone: { _eq: id },
        ...(dateRange?.from || dateRange?.to
          ? {
              date: {
                ...(dateRange?.from ? { _gte: dateRange.from } : {}),
                ...(dateRange?.to ? { _lte: dateRange.to } : {}),
              },
            }
          : {}),
      },
      limit: -1,
    };

    const response = await getItemsFromCollection("timesheet", query);

    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
}
